export const antTheme = {
  token: {
    colorPrimary: '#005537', // Xanh thương hiệu Thế Thảo Pharma
    colorSuccess: '#10b981', // Xanh lá hoàn thành (Emerald)
    colorWarning: '#f59e0b', // Vàng cam cảnh báo (Amber)
    colorError: '#ef4444',   // Đỏ lỗi
    colorInfo: '#005537',
    borderRadius: 8,
    fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif`,
    colorBgBase: '#ffffff',
    colorBgLayout: '#f8fafc',
    colorTextBase: '#1e293b',
    colorTextSecondary: '#64748b',
    fontSize: 14,
    fontSizeHeading1: 28,
    fontSizeHeading2: 22,
    fontSizeHeading3: 18,
    boxShadowSecondary: '0 4px 6px -1px rgb(0 0 0 / 0.05), 0 2px 4px -2px rgb(0 0 0 / 0.05)',
  },
  components: {
    Button: {
      controlHeight: 38,
      borderRadius: 6,
      fontWeight: 500,
    },
    Card: {
      borderRadiusLG: 10,
      colorBorderSecondary: '#e2e8f0',
    },
    Menu: {
      itemBorderRadius: 6,
      itemSelectedColor: '#005537',
      itemSelectedBg: '#f0fdf4',
    },
    Tag: {
      borderRadiusSM: 4,
    },
  },
};
